export default "__VITE_ASSET__dfaa60a4__"